import BaseDrawer from '@/components/BaseDrawer';
import BaseDialog from "@/components/BaseDialog";

// 分产品配置
export function productConfigDrawer ({ props, cbs }) {
  const w = document.body.clientWidth;
  return new BaseDrawer({
    component: ()=>import('./productConfigDrawer'),
    options: {
      size: w>=1200? '1200px': '100%',
      title: '分产品配置',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.remove('f-hide');
      }
    }
  })
}

export function ideaSettingModal ({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('./ideaSettingModal'),
    options: {
      width: '700px',
      title: '创意名称设置',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
    },
    props,
    cbs,
  })
}